export default {
  coins: (state) => state.coins,
}
